import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FIRST_INVESTMENT_MAX, MONTHLY_PLAN_MAX } from '../types';

interface Values {
  firstInvestment?: number;
  monthlyPlan?: number;
}

export const useForm = (
  initialValues: Values,
  minFirstInvestment: number,
  minMonthlyPlan: number,
) =>
  useFormik<Values>({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues,
    validationSchema: Yup.object().shape(
      {
        firstInvestment: Yup.number().when('monthlyPlan', {
          is: (monthlyPlanVal) => !monthlyPlanVal,
          then: Yup.number()
            .required('min')
            .nullable()
            .min(minFirstInvestment, 'min')
            .max(FIRST_INVESTMENT_MAX, 'max'),
          otherwise: Yup.number()
            .nullable()
            .optional()
            .test(
              'zero_or_min',
              'min',
              (value) =>
                [undefined, null, 0].includes(value) || (value as number) >= minFirstInvestment,
            )
            .max(FIRST_INVESTMENT_MAX, 'max'),
        }),
        monthlyPlan: Yup.number().when('firstInvestment', {
          is: (firstInvestmentVal) => !firstInvestmentVal,
          then: Yup.number()
            .required('min')
            .nullable()
            .min(minMonthlyPlan, 'min')
            .max(MONTHLY_PLAN_MAX, 'max'),
          otherwise: Yup.number()
            .nullable()
            .optional()
            .test(
              'zero_or_min',
              'min',
              (value) =>
                [undefined, null, 0].includes(value) || (value as number) >= minMonthlyPlan,
            )
            .max(MONTHLY_PLAN_MAX, 'max'),
        }),
      },
      [['firstInvestment', 'monthlyPlan']],
    ),
    onSubmit: () => {},
  });
